import { useEffect } from 'react';
import { useFetch } from './useFetch';   // your existing hook
import { CustomToast } from '../components';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export const usePushNotification = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);

    useEffect(() => {
        registerPush();
    }, []);

    const registerPush = async () => {
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            console.log('[Push] Not supported in this browser');
            return;
        }

        try {
            const registration = await navigator.serviceWorker.register('/sw.js', {
                scope: '/'
            });

            console.log('[Push] Service worker registered');

            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                console.log('[Push] Permission denied');
                return;
            }

            const keyResponse = await fetchApi('PushNotification/publicKey', 'GET');
            if (!keyResponse?.publicKey) return;

            const applicationServerKey = urlBase64ToUint8Array(keyResponse.publicKey) as any;

            let subscription = await registration.pushManager.getSubscription();

            if (!subscription) {
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: applicationServerKey,
                });
            }

            const subJson = subscription.toJSON();
            await fetchApi('PushNotification/subscribe', 'POST', {
                endpoint: subJson.endpoint,
                p256dh: subJson.keys?.p256dh,
                auth: subJson.keys?.auth,
            });

            console.log('[Push] Subscribed successfully');
        } catch (error) {
            console.error('[Push] Registration failed:', error);
        }
    };
};
